// locales
//import 'dayjs/locale/ar';
// plugins
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone"; // To convert timeZone
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);

export default dayjs;
